exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.AccountActions button.dropdown-item{margin-left:0\n}\n.AccountActions .ellipsis-button{width:2.5em;margin:-0.5em 0;padding:.5em 0;text-align:center\n}\n.AccountActions .ellipsis-button:not(:hover) .icon{color:#b9b9ba;color:var(--lightText, #b9b9ba)\n}", ""]);

// exports
